import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 12h2l2 -5l3 10l3 -10l3 10l3 -10l1.5 5h2.5","key":"svg-0"}]]

/**
 * IconCircuitResistor
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2lyY3VpdC1yZXNpc3RvciIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMiAxMmgybDIgLTVsMyAxMGwzIC0xMGwzIDEwbDMgLTEwbDEuNSA1aDIuNSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/circuit-resistor
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCircuitResistor = createReactComponent('outline', 'circuit-resistor', 'CircuitResistor', __iconNode);

export default IconCircuitResistor;